import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Observable, take } from 'rxjs';
import { AcessoService, LocalUsuario } from '../../services/bas/acesso.service';
import { ConfigService } from '../../services/config.service';
import {
  ESSENTIALS,
  MATERIAL_BUTTONS,
  MATERIAL_FEEDBACK,
  MATERIAL_LAYOUT,
} from '../../utils/shared-components';
import { GlobalVariablesService } from '../../services/global-variables.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MATERIAL_BUTTONS, MATERIAL_FEEDBACK, ESSENTIALS, MATERIAL_LAYOUT],
})
export class HeaderComponent implements OnInit {
  isLoggedIn$: Observable<boolean>;
  ambiente: String;
  envName: String;
  estilo: any;
  locais: LocalUsuario[] = [];
  localAtual: LocalUsuario | null = null;
  filtroLocal = '';
  carregandoLocais = false;
  alterandoLocal = false;
  erroLocais = false;
  @Output('sideNav') sideNav: EventEmitter<boolean> = new EventEmitter();

  private configService = inject(ConfigService);
  private authService = inject(AuthService);
  private acessoService = inject(AcessoService);
  public globalVariables = inject(GlobalVariablesService);

  ngOnInit() {
    this.ambiente = ConfigService.settings.app.environmentName;
    this.envName = ConfigService.settings.app.environmentDescription;
    const toolbar = ConfigService.settings.ui.toolbar;
    this.estilo = {
      'background-color': toolbar.backgroundColor,
      color: toolbar.color,
      height: toolbar.height,
    };
    this.carregaLocais();
  }

  carregaLocais() {
    if (!this.userId) return;

    this.carregandoLocais = true;
    this.erroLocais = false;

    this.acessoService
      .buscaLocalUsuario(this.userId)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          const data = response?.body?.data;
          this.locais = Array.isArray(data) ? data : (data?.registro ?? []);
          this.localAtual = this.locais.find((local) => local.localAtual) ?? null;
          this.carregandoLocais = false;
          this.alterandoLocal = false;
        },
        error: () => {
          this.locais = [];
          this.localAtual = null;
          this.carregandoLocais = false;
          this.alterandoLocal = false;
          this.erroLocais = true;
        },
      });
  }

  selecionaLocal(local: LocalUsuario) {
    if (local.localAtual || this.alterandoLocal) return;

    this.alterandoLocal = true;
    this.acessoService
      .alteraLocalUsuario(this.userId, local.codigoLocal)
      .pipe(take(1))
      .subscribe({
        next: () => {
          window.location.reload();
        },
        error: () => {
          this.alterandoLocal = false;
        },
      });
  }

  atualizaFiltroLocal(event: Event) {
    this.filtroLocal = (event.target as HTMLInputElement).value;
  }

  limpaFiltroLocal() {
    this.filtroLocal = '';
  }

  get locaisFiltrados(): LocalUsuario[] {
    const filtro = this.normalizaTexto(this.filtroLocal);
    if (!filtro) return this.locais;

    return this.locais.filter((local) =>
      this.normalizaTexto(
        [local.codigoLocal, local.nomeLocal, local.nomeFilial].join(' '),
      ).includes(filtro),
    );
  }

  descricaoLocal(local: LocalUsuario | null): string {
    if (!local) return 'Nenhum local disponível';

    const nomeFilial = local.nomeFilial?.trim();
    const nomeLocal = local.nomeLocal?.trim();
    if (nomeFilial && nomeLocal && nomeFilial !== nomeLocal) {
      return `${nomeFilial} — ${nomeLocal}`;
    }
    return nomeLocal || nomeFilial || `Local ${local.codigoLocal}`;
  }

  private normalizaTexto(valor: unknown): string {
    return String(valor ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }

  onLogout() {
    this.authService.logout();
  }

  public get name() {
    return this.authService.getLoggedUserName();
  }

  public get userId() {
    return this.authService.getUserId();
  }

  public get userRowid() {
    return this.authService.getLoggedUserRowid();
  }

  toggleSidenav() {
    this.sideNav.emit();
  }
}
